export const OrderTaxInvoicePublish = () => {
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">게시판 검색</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-secondary w-100px">수정</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">상태</label>
                            <select className="form-select w-150px">
                                <option>수주</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row">
                            <label for="" className="form-label frm_label">등록기간</label>
                            <div className="frm_field">
                                <div className="frm_field input_date">
                                    <input type="date" className="form-control" />
                                    <span className="txt_range">~</span>
                                    <input type="date" className="form-control" />
                                    <button className="btn btn-info btn_search">
                                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">게시판 목록(<span>23</span>건)</h6>
                    <div className="table_toolbar">
                        <button className="btn btn-dark w-100px">추가</button>
                        <button className="btn btn-outline-dark w-100px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt="" />선택삭제</button>
                    </div>
                </div>

                <table className="table table-bordered my_table">
                    <thead>
                        <tr>
                            <th style={{ width: "4.4%" }}>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </th>
                            <th>세금계산서<br />
                                발행일자</th>
                            <th>담당자</th>
                            <th>매출처</th>
                            <th>공급가액</th>
                            <th>부가세</th>
                            <th>금액</th>
                            <th>세금계산서<br />
                                담당자</th>
                            <th>이메일</th>
                            <th>비고</th>
                            <th>마감번호</th>
                            <th>세금계산서 번호</th>
                            <th>상태</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">주식회사 구구구</td>
                            <td className="text-end">12345</td>
                            <td className="text-end">12345</td>
                            <td className="text-end">12345</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-end">1234_1234</td>
                            <td className="text-end">1234_1234</td>
                            <td className="text-center">발행 요청</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">주식회사 구구구</td>
                            <td className="text-end">0</td>
                            <td className="text-end">0</td>
                            <td className="text-end">0</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-end"></td>
                            <td className="text-end"></td>
                            <td className="text-center">발행</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">주식회사 구구구</td>
                            <td className="text-end">12345</td>
                            <td className="text-end">12345</td>
                            <td className="text-end">12345</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-end"></td>
                            <td className="text-end"></td>
                            <td className="text-center"></td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">주식회사 구구구</td>
                            <td className="text-end">12345</td>
                            <td className="text-end">12345</td>
                            <td className="text-end">12345</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-end"></td>
                            <td className="text-end"></td>
                            <td className="text-center"></td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">주식회사 구구구</td>
                            <td className="text-end">12345</td>
                            <td className="text-end">12345</td>
                            <td className="text-end">12345</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-end"></td>
                            <td className="text-end"></td>
                            <td className="text-center"></td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">주식회사 구구구</td>
                            <td className="text-end">12345</td>
                            <td className="text-end">12345</td>
                            <td className="text-end">12345</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-end"></td>
                            <td className="text-end"></td>
                            <td className="text-center"></td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">주식회사 구구구</td>
                            <td className="text-end">12345</td>
                            <td className="text-end">12345</td>
                            <td className="text-end">12345</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-end"></td>
                            <td className="text-end"></td>
                            <td className="text-center"></td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">주식회사 구구구</td>
                            <td className="text-end">12345</td>
                            <td className="text-end">12345</td>
                            <td className="text-end">12345</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-end"></td>
                            <td className="text-end"></td>
                            <td className="text-center"></td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">주식회사 구구구</td>
                            <td className="text-end">12345</td>
                            <td className="text-end">12345</td>
                            <td className="text-end">12345</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-end"></td>
                            <td className="text-end"></td>
                            <td className="text-center"></td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">2024-05-05</td>
                            <td className="text-center">이이이</td>
                            <td className="text-center">주식회사 구구구</td>
                            <td className="text-end">12345</td>
                            <td className="text-end">12345</td>
                            <td className="text-end">12345</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-end"></td>
                            <td className="text-end"></td>
                            <td className="text-center"></td>
                        </tr>
                    </tbody>
                </table>

                <div className="pagination-container">
                    <ul>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                alt="First Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                alt="Previous Page"
                                className=""
                            />
                        </li>
                        <li className="active">1</li>
                        <li className="">2</li>
                        <li className="">3</li>
                        <li className="">4</li>
                        <li className="">5</li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                alt="Next Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                alt="Last Page"
                                className=""
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}